import { connect } from 'react-redux';
import { Dispatch, AnyAction } from 'redux';
import RootState from '../../modules/rootState';
import Payment, { StateFromProps, DispatchFromProps, OwnProps } from './Payment';
import * as providerData from 'src/modules/entities/provider';
import * as workflowData from 'src/modules/entities/workflow';
import * as paymentData from 'src/modules/entities/payment';
import Workflow from 'src/models/workflow';
import { PaidPayment } from 'src/models/payment';
import * as clinicData from 'src/modules/entities/clinic';

const mapStateToProps = (rootState: RootState, props: OwnProps): StateFromProps => ({
    registrationId: workflowData.selectors.getRegistrationId(rootState),
    workflow: workflowData.selectors.getWorkflow(rootState),

    //provider: providerData.selectors.getProviderInfoPayment(rootState),
    provider: clinicData.selectors.getProviderInformationPayment(rootState),
    submitting: paymentData.selectors.submitting(rootState),
    submitted: paymentData.selectors.submitted(rootState),

    //data from Vendor
    paymentProducts: paymentData.selectors.getPaymentProducts(rootState),

    errorMessage: paymentData.selectors.errorMessage(rootState),
    messageType: paymentData.selectors.messageType(rootState),
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): DispatchFromProps => ({
    updateWorkflow: (workflow: Workflow): void => {
        dispatch(workflowData.actions.storeWorkflowData(workflow));
    },
    submitPaidProducts: (paidProducts: PaidPayment): void => {
        dispatch(paymentData.actions.submitPaidProductsAsync(paidProducts));
    },
    getPaymentProducts: (): void => {
        dispatch(paymentData.actions.getPaymentProductsAsync());
    },
    submitToVendor: (registrationId: string): void => {
        dispatch(providerData.actions.submitToVendorAsync(registrationId));
    },
    resetSubmitStatus: (): void => {
        dispatch(providerData.actions.resetSubmitStatus());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Payment);


// WEBPACK FOOTER //
// ./src/components/Payment/Payment.container.ts